(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-overview"] && !Shopify.designMode) return;
  try {
    
  // Keep the wine overview (vintage in stats bar / facts) in sync on variant switch without a reload.
  // Horizon's variant picker fetches the full product page and dispatches `variant:update` carrying
  // the re-rendered document in `event.detail.data.html`. The marker element carries the section id,
  // from which we derive the `shopify-section-<id>` wrapper and replace its content with the freshly
  // rendered one. Product-card / quick-add fragments don't contain this section, so we bail out.
  (function () {
    function syncWineOverview(event) {
      var doc = event && event.detail && event.detail.data && event.detail.data.html;
      if (!doc) return;

      document.querySelectorAll('[data-wine-overview-id]').forEach(function (marker) {
        var sectionId = 'shopify-section-' + marker.getAttribute('data-wine-overview-id');
        var current = document.getElementById(sectionId);
        var updated = doc.getElementById(sectionId);
        if (!current || !updated) return;
        current.innerHTML = updated.innerHTML;
      });
    }

    document.addEventListener('variant:update', syncWineOverview);
  })();

  } catch(e) { console.error(e); }
})();
})();
